import { TimelineLite } from 'gsap'
import AppData from '../../api/AppData'
import AppMap from '../../components/AppMap/AppMap.vue'
import AppSidebar from '../../components/AppSidebar/AppSidebar.vue'
import AppVideo from '../../components/AppVideo/AppVideo.vue'
import AppFooter from '../../components/AppFooter/AppFooter.vue'
import AppMarker from '../../components/AppMarker/AppMarker.vue'
import AppLoading from '../../components/AppLoading/AppLoading.vue'
import AppTitle from '../../components/AppTitle/AppTitle.vue'

import { mapState } from 'vuex'


export default {
    components: {
        AppMap,
        AppSidebar,
        AppFooter,
        AppVideo,
        AppMarker,
        AppLoading,
        AppTitle,
        TimelineLite
    },

    mounted() {
        const {sliderMenu, footer, map} = this.$refs
        const timeline = new TimelineLite() 

        timeline.from(sliderMenu, 2, {
            opacity: 1,
            delay: .5,
        });

        
        timeline.from(footer, 2, {
            opacity: 1,
            delay: .5,
        });
        

        timeline.from(map, 2, {
            opacity: 1,
            delay: .5,
        });

        setTimeout(() => {
            this.$store.commit('isLoaded');
        }, 4000);
    },

    data() {
        return {
            data: AppData,
        }
    },

    computed: {
        ...mapState(['progress', 'loaded', 'selectedVideo'])
    },

    watch: {
        progress(val) {
            if (val > 97) {
                setTimeout(() => {
                    this.$store.commit('isLoaded')
                }, 2800)
            }
        }
    }
}
